import moment, { Moment } from "moment"

const isInvalidEndDate = (endDate: Moment, startDate: Moment) => {
  return moment(startDate).add(1, "day").isAfter(endDate, "day")
}

export default isInvalidEndDate
